import { useState } from "react";
import { NEWS } from "../../mocks/newsData";
import Header from "./components/Header";
import BreakingTicker from "./components/BreakingTicker";
import Masthead from "./components/Masthead";
import LeadPanel from "./components/LeadPanel";
import LiveSidebar from "./components/LiveSidebar";
import DepthSection from "./components/DepthSection";
import FaqSection from "./components/FaqSection";
import AboutSection from "./components/AboutSection";
import ContactSection from "./components/ContactSection";
import Footer from "./components/Footer";
import BackToTop from "./components/BackToTop";
import ArticleModal from "./components/ArticleModal";

export default function Home() {
  const [openId, setOpenId] = useState<string | null>(null);
  const activeArticle = openId ? NEWS.find((n) => n.id === openId) || null : null;

  const openArticle = (id: string) => {
    setOpenId(id);
    window.scrollTo({ top: 0, behavior: "auto" });
  };

  return (
    <div id="top" className="min-h-screen bg-background-50 font-sans">
      <Header />

      <main>
        <BreakingTicker />
        <Masthead />

        {/* 焦点速递 + 实时侧栏 */}
        <section className="mx-auto max-w-[1440px] px-4 py-8 md:px-6 md:py-10" id="focus">
          <div className="grid grid-cols-1 gap-6 lg:grid-cols-12">
            <div className="lg:col-span-8">
              <LeadPanel onOpen={openArticle} />
            </div>
            <aside className="lg:col-span-4">
              <LiveSidebar onOpen={openArticle} />
            </aside>
          </div>
        </section>

        <DepthSection onOpen={openArticle} />
        <FaqSection />
        <AboutSection />
        <ContactSection />
      </main>

      <Footer />
      <BackToTop />

      {activeArticle && (
        <ArticleModal
          article={activeArticle}
          onClose={() => setOpenId(null)}
          onOpen={setOpenId}
        />
      )}
    </div>
  );
}